import { Injectable, inject } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Conta} from '../model/conta.model';
import {PageModel} from '../model/page-mode.model';
import {ContaFiltro} from '../model/conta-filtro.model';
import {ContaInstagramAuthUrl, ContaInstagramConexao, ContaInstagramTestarConexao} from '../model/conta-instagram-conexao.model';

@Injectable({
  providedIn: 'root'
})
export class ContaService {
  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}/conta`;

  buscarTodosNumerosAtivos(): Observable<Conta[]>{
    return this.http.get<Conta[]>(`${this.urlBase}/buscar-todos`);
  }

  buscarTodosNumerosFiltrado(filtro: ContaFiltro, page: number, limit: number): Observable<PageModel> {
    return this.http.post<PageModel>(`${this.urlBase}/filtrado`, filtro, {
      params: {
        page: page,
        limit: limit
      }
    });
  }

  salvarEditarNumero(numero: Conta): Observable<Conta> {
    return this.http.post<Conta>(`${this.urlBase}`, numero);
  }

  buscarNumerosPorSetor(idSetor: number): Observable<Conta[]> {
    return this.http.get<Conta[]>(`${this.urlBase}/por-setor/${idSetor}`);
  }

  iniciarConexaoInstagram(dados: ContaInstagramConexao): Observable<ContaInstagramAuthUrl> {
    return this.http.post<ContaInstagramAuthUrl>(`${this.urlBase}/instagram/iniciar-conexao`, dados);
  }

  processarCallbackInstagram(code: string, state: string): Observable<Conta> {
    return this.http.post<Conta>(`${this.urlBase}/instagram/callback`, { code, state });
  }

  desconectarInstagram(contaId: number): Observable<void> {
    return this.http.delete<void>(`${this.urlBase}/${contaId}/instagram/disconnect`);
  }

  testarConexaoInstagram(contaId: number): Observable<ContaInstagramTestarConexao> {
    return this.http.get<ContaInstagramTestarConexao>(`${this.urlBase}/${contaId}/instagram/testar-conexao`);
  }
}
